export enum Endpoint {
  imageUrls = 'imageUrls',
  root_api = 'http://bookscreamapi',
  root_ui = 'http://localhost:4200',
}
